import dayjs from 'dayjs';

export default function sortSectionSchedule<T extends { day: string }>(
  list: T[],
) {
  const days = Array.from({ length: 7 }, (_, i) =>
    dayjs()
      .day(i + 1)
      .format('dd')
      .toUpperCase(),
  );

  return list
    .map((item) => {
      return {
        dayIndex: days.findIndex((day) => day === item.day.toUpperCase()),
        item,
      };
    })
    .sort((a, b) => a.dayIndex - b.dayIndex)
    .map((item) => item.item);
}
